// extracted by mini-css-extract-plugin
export default {"container":"SupportGroupsGrid_container__7mCUY","users":"SupportGroupsGrid_users__1-xoc","pagination":"SupportGroupsGrid_pagination__x3C7X"};